export const fi = {
  "account": {
    "k1": "Aloituspaketti",
    "k2": "Hanki 125 krediittiä. Täydellinen alkuun pääsemiseen ja ydinominaisuuksien testaamiseen.",
    "k3": "Pro-paketti",
    "k4": "Hanki 250 krediittiä. Paras vastine säännölliseen käyttöön.",
    "k5": "Business-paketti",
    "k6": "Hanki 1700 krediittiä. Tehokäyttäjille ja yrityksille, sisältää 25 % alennuksen.",
    "k7": "Enterprise-paketti",
    "k8": "Hanki 5000 krediittiä. Kattavin paketti institutionaalisille asiakkaille, sisältää 50 % alennuksen.",
    "k9": "Ladataan tilitietoja...",
    "k10": "Tilin hallinta",
    "k11": "Krediittisaldo",
    "k12": "Uudet käyttäjät saavat 125 krediittiä (arvo 50 $) aloitusta varten!",
    "k13": "Krediittisi ovat vähissä. Osta lisää, jotta voit jatkaa tekoälyominaisuuksien käyttöä ilman keskeytyksiä.",
    "k14": "Onko sinulla alennuskoodi?",
    "k15": "Lunasta koodi",
    "k16": "Osta lisää krediittejä",
    "k17": "Osta nyt"
  },
  "aIChatWindow": {
    "k1": "Avaa/sulje tekoälyavustaja",
    "k2": "Tekoälyavustaja",
    "k3": "Kysy portfoliostasi",
    "k4": "Miten voin auttaa sinua tänään?",
    "k5": "Esitä kysymys..."
  },
  "allActivities": {
    "k1": "Ladataan toimintoja...",
    "k2": "Krediittien käyttöloki",
    "k3": "Ei näytettäviä toimintoja."
  },
  "auth": {
    "k1": "CRE Dominion",
    "k2": "Luo tili",
    "k3": "Tervetuloa takaisin",
    "k4": "Rekisteröidy aloittaaksesi",
    "k5": "Kirjaudu tilillesi",
    "k6": "Sähköpostiosoite",
    "k7": "Salasana",
    "k8": "Tai jatka käyttäen",
    "k9": "Google",
    "k10": "Onko sinulla jo tili? Kirjaudu sisään",
    "k11": "Eikö sinulla ole vielä tiliä? Rekisteröidy"
  },
  "bulkLeaseUploader": {
    "k1": "Ladataan kiinteistöjä...",
    "k2": "Virhe:",
    "k3": "Vuokrasopimusten lataustyökalu",
    "k4": "Kiinteistö (pakollinen):",
    "k5": "Valitse kiinteistö",
    "k6": "Kiinteistöjä ei löytynyt. Lisää ensin kiinteistö.",
    "k7": "Lataa tiedostoja",
    "k8": "Lataa kansio",
    "k9": "Valitse vuokrasopimukset (PDF, kuvat):",
    "k10": "Valitse vuokrasopimuskansio (lataa kaikki sisältyvät PDF-tiedostot/kuvat):",
    "k11": "Lataa vuokrasopimukset",
    "k12": "Valittu",
    "k13": "tiedosto",
    "k14": "Vuokrasopimusten lataushistoria",
    "k15": "Ladataan historiaa...",
    "k16": "Lataushistoriaa ei löytynyt.",
    "k17": "Työn ID",
    "k18": "Ladattu",
    "k19": "Tiedostojen määrä",
    "k20": "Tila",
    "k21": "Toiminnot",
    "k22": "Näytä"
  },
  "bulkLeaseValidator": {
    "k1": "Ladataan massavalidointityötä...",
    "k2": "Ladataan tiedostoja... Tämä prosessi voi kestää jonkin aikaa dokumenttien määrästä ja koosta riippuen. Voit siirtyä muualle; prosessi jatkuu taustalla.",
    "k3": "Tälle työn ID:lle ei löytynyt tietueita.",
    "k4": "Massavalidointi (Työn ID:",
    "k5": "Takaisin lataustyökaluun",
    "k6": "Hyväksytään valittuja...",
    "k7": "Hyväksy valitut vuokrasopimukset",
    "k8": "Hyväksytään kaikkia...",
    "k9": "Hyväksy kaikki odottavat vuokrasopimukset",
    "k10": "Tiedostonimi",
    "k11": "Tila",
    "k12": "Toiminnot",
    "k13": "Virhe:"
  },
  "calendarEventModal": {
    "k1": "Tyyppi:",
    "k2": "Alkaa:",
    "k3": "Päättyy:",
    "k4": "Kiinteistötunnus:",
    "k5": "Järjestelmän vuokrasopimustunnus:",
    "k6": "Mukautettu vuokrasopimustunnus:",
    "k7": "Tapahtumatunnus:",
    "k8": "Sulje"
  },
  "calendarView": {
    "k1": "Ladataan kalenteria...",
    "k2": "Virhe:",
    "k3": "Kriittisten päivämäärien kalenteri"
  },
  "calendarViewWrapper": {
    "k1": "Kalenteri"
  },
  "dashboard": {
    "k1": "Kojelaudan yleisnäkymä",
    "k2": "Virhe:",
    "k3": "Kojelaudan tietoja ei saatavilla.",
    "k4": "Kiinteistöjä yhteensä",
    "k5": "Vuokralaisia yhteensä",
    "k6": "Vuokrasopimuksia yhteensä",
    "k7": "Vuokrasopimusten erääntymiset",
    "k8": "Kiinteistöjen käyttöaste",
    "k9": "Kiinteistötyypit",
    "k10": "Tyhjyysasteen trendit"
  },
  "dealSourcing": {
    "k1": "Ladataan hankkeita...",
    "k2": "Virhe:",
    "k3": "Hankkeiden etsintä ja hallinta",
    "k4": "Muokkaa kohdetta",
    "k5": "Lisää uusi kohde",
    "k6": "Kohteen nimi",
    "k7": "Valitse tyyppi",
    "k8": "Hankinta",
    "k9": "Myynti",
    "k10": "Kehityshanke",
    "k11": "Valitse tila",
    "k12": "Myyntiputki",
    "k13": "Due Diligence",
    "k14": "Suljettu",
    "k15": "Hylätty",
    "k16": "Linkitä kiinteistöön (valinnainen)",
    "k17": "Tavoitehinta",
    "k18": "Tarjoushinta",
    "k19": "Kaupantekopäivä:",
    "k20": "Lähde",
    "k21": "Kuvaus",
    "k22": "Päivitä kohde",
    "k23": "Lisää kohde",
    "k24": "Peruuta muokkaus",
    "k25": "Omat kohteet",
    "k26": "Ei kohteita. Lisää uusi ylhäältä!",
    "k27": "Tila:",
    "k28": "Kiinteistö:",
    "k29": "Tavoitehinta:",
    "k30": "Tarjoushinta:",
    "k31": "Lähde:",
    "k32": "Kuvaus:",
    "k33": "Muokkaa",
    "k34": "Poista"
  },
  "documents": {
    "k1": "Ladataan dokumentteja...",
    "k2": "Virhe:",
    "k3": "Asiakirjojen hallinta",
    "k4": "Lataa uusi asiakirja",
    "k5": "Kiinteistö (pakollinen):",
    "k6": "Valitse kiinteistö",
    "k7": "Valitse asiakirja(t):",
    "k8": "Lataa asiakirja(t)",
    "k9": "Asiakirjasi",
    "k10": "Asiakirjoja ei löytynyt. Lataa ensimmäinen yllä!",
    "k11": "Tyyppi:",
    "k12": "Kiinteistötunnus:",
    "k13": "Kuvaus:",
    "k14": "Ladattu:",
    "k15": "Näytä",
    "k16": "Muokkaa",
    "k17": "Poista"
  },
  "editCompModal": {
    "k1": "Muokkaa vertailukauppaa",
    "k2": "Osoite:",
    "k3": "Kaupantekopäivä:",
    "k4": "Kauppahinta:",
    "k5": "Pinta-ala (sq ft):",
    "k6": "Peruuta",
    "k7": "Tallenna muutokset"
  },
  "editDocumentModal": {
    "k1": "Muokkaa asiakirjaa",
    "k2": "Tiedostonimi:",
    "k3": "Kuvaus:",
    "k4": "Peruuta",
    "k5": "Tallenna muutokset"
  },
  "editLeaseModal": {
    "k1": "Muokkaa vuokrasopimusta",
    "k2": "Mukautettu vuokrasopimustunnus:",
    "k3": "Vuokralaisen nimi:",
    "k4": "Alkamispäivä:",
    "k5": "Päättymispäivä:",
    "k6": "Vuokran määrä:",
    "k7": "Peruuta",
    "k8": "Tallenna muutokset"
  },
  "editTransactionModal": {
    "k1": "Muokkaa transaktiota",
    "k2": "Tyyppi:",
    "k3": "Kuvaus:",
    "k4": "Summa:",
    "k5": "Eräpäivä:",
    "k6": "Maksupäivä:",
    "k7": "Kategoria:",
    "k8": "Tuotto",
    "k9": "Kulu",
    "k10": "Peruuta",
    "k11": "Tallenna muutokset"
  },
  "fAQ": {
    "k1": "Mikä on CRE Dominion?",
    "k2": "CRE Dominion on kattava, tekoälypohjainen alusta, joka on suunniteltu kaupallisen kiinteistöalan (CRE) ammattilaisille. Se virtaviivaistaa kiinteistönhallintaa, investointikohteiden hankintaa, vuokrasopimusten analysointia, markkina-analyyseja ja paljon muuta, auttaen sinua tekemään dataperusteisia päätöksiä kiinteistöliiketoimintasi kasvattamiseksi.",
    "k3": "Kenelle CRE Dominion on tarkoitettu?",
    "k4": "CRE Dominion on kehitetty laajalle joukolle CRE-alan ammattilaisia, kuten kiinteistöjen omistajille, isännöitsijöille, varainhoitajille, välittäjille ja sijoittajille. Hallinnoitpa sitten yksittäistä kohdetta tai laajaa portfoliota, alustamme tarjoaa työkalut menestykseesi.",
    "k5": "Mitkä ovat CRE Dominionin keskeiset ominaisuudet?",
    "k6": "Keskeisiä ominaisuuksiamme ovat tekoälyavusteinen vuokrasopimusten analysointi, edistynyt investointikohteiden hankinta ja analyysi, kattava kiinteistö- ja vuokralaishallinta, markkina-analyysit ja ennustavat trendit, kiinteistöjen arvostus, muokattava raportointi sekä tietoturvallinen dokumenttien hallinta.",
    "k7": "Miten vuokrasopimusten analysointi toimii?",
    "k8": "Tekoälypohjainen vuokrasopimusten analysointityökalumme poimii automaattisesti avaintiedot vuokrasopimuksistasi, kuten alkamis- ja päättymispäivät, vuokran määrät, sopimusehdot ja paljon muuta. Tämä säästää lukemattomia tunteja manuaalista tiedonsyöttöä ja vähentää virheiden riskiä.",
    "k9": "Onko datani turvassa?",
    "k10": "Kyllä, tietoturva on ensisijainen prioriteettimme. Käytämme alan johtavia turvatoimenpiteitä, mukaan lukien salausta ja suojattua pilvitallennusta, arkaluonteisten tietojesi suojaamiseksi. Datanne on turvassa, suojattuna ja aina käytettävissänne.",
    "k11": "Minkä tyyppisiä kiinteistöjä voin hallinnoida CRE Dominionilla?",
    "k12": "Voit hallinnoida monipuolisesti erilaisia kaupallisia kiinteistöjä, kuten toimistorakennuksia, liiketiloja, teollisuuskiinteistöjä ja asuinkerrostaloja.",
    "k13": "Miten investointikohteiden hankinta (deal sourcing) toimii?",
    "k14": "Investointikohteiden hankintamoduulimme hyödyntää edistyneitä algoritmeja ja markkinadataa auttaakseen sinua tunnistamaan ja arvioimaan kriteerejäsi vastaavia potentiaalisia sijoituskohteita. Voit analysoida kauppoja, suorittaa due diligence -tarkastuksia ja seurata hankintaputkeasi yhdessä paikassa.",
    "k15": "Voinko luoda mukautettuja raportteja?",
    "k16": "Kyllä, alustamme sisältää tehokkaan raportointimoottorin, jonka avulla voit luoda laajan valikoiman muokattavia raportteja portfolion suorituskyvystä, taloudesta, vuokraustoiminnasta ja muusta. Nämä raportit voidaan räätälöidä sidosryhmiesi tarpeiden mukaisesti.",
    "k17": "Mikä on hinnoittelumalli?",
    "k18": "CRE Dominion hyödyntää joustavaa krediittipohjaista järjestelmää. Ostamillasi krediiteillä käytät tekoälypohjaisia toiminnallisuuksia ja kehittyneitä analytiikkatyökaluja. Tämä mahdollistaa kustannustehokkaan käytön, jossa maksat vain tarvitsemastasi kapasiteetista. Tarkista krediittien ostovaihtoehdot ja käyttöhistoria tiliasetuksistasi.",
    "k19": "Miten pääsen alkuun?",
    "k20": "Aloittaminen on vaivatonta. Voit rekisteröityä ilmaiseen kokeiluun suoraan verkkosivustoltamme. Rekisteröitymisen jälkeen voit lisätä kiinteistöjäsi ja aloittaa alustan ominaisuuksiin tutustumisen välittömästi.",
    "k21": "&larr; Takaisin etusivulle",
    "k22": "Usein kysytyt kysymykset"
  },
  "financialsLedger": {
    "k1": "Ladataan taloustietoja...",
    "k2": "Virhe:",
    "k3": "Tulot",
    "k4": "Menot",
    "k5": "Ei",
    "k6": "tietueita löytyi.",
    "k7": "Tyyppi",
    "k8": "Kuvaus",
    "k9": "Summa",
    "k10": "Eräpäivä",
    "k11": "Maksupäivä",
    "k12": "Toiminnot",
    "k13": "Muokkaa",
    "k14": "Poista",
    "k15": "Lisää uusi taloustapahtuma",
    "k16": "Kategoria",
    "k17": "Meno",
    "k18": "Tapahtumatyyppi",
    "k19": "Lisää tapahtuma",
    "k20": "Taloudellinen yhteenveto"
  },
  "homePage": {
    "k1": "Starter-paketti",
    "k2": "Ihanteellinen alkuvaiheen deal-seulontaan ja tekoälypohjaiseen vuokrasopimusten analysointiin.",
    "k3": "Pro-paketti",
    "k4": "Paras valinta aktiivisille hankintatiimeille, välittäjille ja asset managereille.",
    "k5": "Business-paketti",
    "k6": "Boutique-rahastoille, perhetoimistoille ja korkean volyymin hankintaputkiin.",
    "k7": "Enterprise-paketti",
    "k8": "Institutionaalisen tason skaalautuvuus REIT-yhtiöille, velkarahastoille ja suurille kiinteistöportfolioille.",
    "k9": "CRE Dominion | Tekoälypohjainen kaupallisen kiinteistöalan underwriting- ja vuokrahallinnan käyttöjärjestelmä",
    "k10": "CRE Dominion -logo",
    "k11": "Live-analyysityökalu",
    "k12": "Hinnoittelu",
    "k13": "Tietopankki",
    "k14": "Yhteystiedot",
    "k15": "Kirjaudu sisään",
    "k16": "Institutionaalinen CRE-underwriting",
    "k17": "10 sekunnissa. Ilman taulukkolaskentaa.",
    "k18": "Lopeta kauppojen menettäminen hitaan manuaalisen due diligence -prosessin vuoksi. CRE Dominion yhdistää automatisoidun tekoälypohjaisen vuokrasopimusten analysoinnin ja institutionaalisen rahoitusmallinnuksen, kattaen US Cap Rate -mallit, UK Net Initial Yield -tuotot sekä eurooppalaiset standardit.",
    "k19": "Käynnistä Live-analyysityökalu ↓",
    "k20": "Aloita ilmaiseksi (125 krediittiä)",
    "k21": "Ei vaadi luottokorttia",
    "k22": "Yhteensopiva US, UK &amp; Pohjoismaiden/EU:n kanssa",
    "k23": "125 ilmaista aloituskrediittiä",
    "k24": "Institutionaalinen työnkulun automatisointi",
    "k25": "Koko kaupallinen työnkulkusi yhtenäistettynä yhdelle alustalle.",
    "k26": "Suunniteltu alusta alkaen hankintapäälliköille, välittäjille ja pääomasijoittajille, jotka vaativat nopeutta tinkimättä auditointitarkkuudesta.",
    "k27": "10 sekunnin tekoälypohjainen vuokrasopimusten analysointi",
    "k28": "Poimi avainpäivämäärät, vuokrankorotukset, irtisanomisoikeudet, vakuutusvelvoitteet ja vuokralaiskovenantit 80-sivuisista sopimuksista sekunneissa 99,9 % tarkkuudella.",
    "k29": "Monijurisdiktiollinen rahoitusmallinnus",
    "k30": "Natiivi mallinnus US Triple Net (NNN) Cap Rateille, UK Full Repairing &amp; Insuring (FRI) Net Initial Yield -tuotoille sekä pohjoismaisille/eurooppalaisille metrisille vuokrasopimuksille (`m²`).",
    "k31": "Tekoälyohjattu kauppojen hankinta &amp; pipeline",
    "k32": "Keskitä potentiaaliset hankinnat, seuraa tarjousmääräaikoja, hallitse underwriting-statusta ja luo sijoittajavalmiita tiivistelmiä yhtenäisessä pipeline-näkymässä.",
    "k33": "Ennakoiva markkinatrendien analyysi",
    "k34": "Ennusta Cap Rate -kehitystä, vajaakäyttötrendejä ja osa-alueiden vuokrakasvua hyödyntämällä historiallista telemetriaa ja reaaliaikaista vertailukauppadataa.",
    "k35": "Välitön arvostus &amp; DCF-skenaariot",
    "k36": "Suorita kassavirtamallinnus (DCF), suora kapitalisointi ja vertailukauppa-analyysit rinnakkain stressitestataksesi exit Cap Rate -tavoitteita ja vivutettuja tuottoja.",
    "k37": "Enterprise Vault &amp; SOC-tietoturva",
    "k38": "Eristetty Google Cloud -tallennus tiukalla IAM-valtuutuksella. Omistusoikeudellisia vuokraluetteloita, T-12-raportteja tai vuokrasopimuksia ei koskaan jaeta tai syötetä julkisiin LLM-malleihin.",
    "k39": "Interaktiivinen live-demo",
    "k40": "Testaa tekoälypohjainen vuokrasopimusmoottorimme millä tahansa ehdolla",
    "k41": "Liitä vuokrasopimuksen ehto (esim. vahingonkorvaus, irtisanomisoikeus, elinkustannusindeksitarkistus, yhteisvuokralaisuus) tai lataa yhden sivun sopimus alla. Saat välittömän riskianalyysin ja neuvottelusuositukset.",
    "k42": "Läpinäkyvä ja suvereeni hinnoittelu",
    "k43": "Maksa vain siitä, mitä analysoit.",
    "k44": "Ei pakollisia 5 000 dollarin vuotuisia käyttäjäkohtaisia sopimuksia. Ei myyntiesittelyjä. Aloita välittömästi 125 ilmaisella aloituspisteellä rekisteröitymisen yhteydessä ja täydennä saldoa portfoliosi kasvaessa.",
    "k45": "Suosituin",
    "k46": "kertamaksu",
    "k47": "n.",
    "k48": "Analyysipisteet",
    "k49": "Aloita →",
    "k50": "Tarvitsetko räätälöityjä yritysvolyymeja, on-premise-käyttöönottoja tai dedikoituja API-kiintiöitä? Ota yhteys tekniseen tiimiimme osoitteessa",
    "k51": "Lopeta rahan jättäminen pöydälle.",
    "k52": "Liity niiden kiinteistöalan ammattilaisten joukkoon, jotka käyttävät tekoälyä vuokrasopimusten abstraktioiden automatisointiin, off-market-diilien löytämiseen ja portfolion sijoitetun pääoman tuoton (ROI) maksimointiin Yhdysvalloissa, Isossa-Britanniassa ja Euroopassa.",
    "k53": "Aloita ilmaiseksi →",
    "k54": "Testaa diilien seulontatyökalua",
    "k55": "Luottokorttia ei vaadita • Välitön tilin käyttöönotto 125 ilmaisella pisteellä",
    "k56": "Korkean tarkkuuden käyttöjärjestelmä kaupalliseen kiinteistöliiketoimintaan. Automatisoitu tekoälypohjainen vuokrasopimusten abstraktio, underwriting-mallinnus ja portfolioäly.",
    "k57": "&copy;",
    "k58": "CRE Dominion. Kaikki oikeudet pidätetään.",
    "k59": "Facebook",
    "k60": "Instagram",
    "k61": "LinkedIn",
    "k62": "Google Play",
    "k63": "Tietosuojakäytäntö",
    "k64": "Käyttöehdot",
    "k65": "UKK"
  },
  "kPISection": {
    "k1": "Näytä tiedot"
  },
  "leaseAbstraction": {
    "k1": "Vuokrasopimusten abstraktio",
    "k2": "Valitse kiinteistö:",
    "k3": "-- Valitse kiinteistö --",
    "k4": "Lataa vuokrasopimus (PDF, PNG, JPG):",
    "k5": "Lataa ja abstrahoi",
    "k6": "Puretut vuokrasopimukset",
    "k7": "Vuokrasopimuksen tunnus:",
    "k8": "Tila:",
    "k9": "Purettu vuokrasopimusdata (tunnus:",
    "k10": "Hyväksy vuokrasopimus",
    "k11": "Muokkaa vuokrasopimusta",
    "k12": "Poista vuokrasopimus",
    "k13": "Tallenna muutokset",
    "k14": "Peruuta",
    "k15": "Kiinteistötunnus:",
    "k16": "Asiakirjan URL-osoite:",
    "k17": "Näytä asiakirja",
    "k18": "Tekoälyn purkama data:",
    "k19": "Vuokrasopimuksen alkamispäivä:",
    "k20": "Vuokrasopimuksen päättymispäivä:",
    "k21": "Kuukausivuokra:",
    "k22": "Vuokravakuus:",
    "k23": "Vuokralaisen nimi:",
    "k24": "Vuokranantajan nimi:",
    "k25": "Kiinteistön osoite:",
    "k26": "Erityistä dataa ei löytynyt.",
    "k27": "Koko purettu teksti:"
  },
  "leaseAbstractionSettings": {
    "k1": "Ladataan vuokrasopimusten purkuasetuksia...",
    "k2": "Vuokrasopimusten purkuasetukset",
    "k3": "Valitse esimääritetyt ehdot:",
    "k4": "Muu (määritä alla)",
    "k5": "Mukautetut ehdot (pilkulla erotettuna):",
    "k6": "esim. irtisanomisehto, jälleenvuokrausoikeus",
    "k7": "Tallenna vuokrasopimusehdot"
  },
  "leaseExpirationChart": {
    "k1": "Erääntyvien vuokrasopimusten määrä",
    "k2": "Vuokrasopimusten erääntyminen kuukausittain",
    "k3": "Vuokrasopimusten määrä"
  },
  "leases": {
    "k1": "Virhe:",
    "k2": "Vuokrasopimukset",
    "k3": "Peruuta uuden sopimuksen lisäys",
    "k4": "Lisää uusi vuokrasopimus",
    "k5": "Vuokrasopimusten lataus",
    "k6": "Vuokrasopimusten abstraktio",
    "k7": "Kiinteistötunnus:",
    "k8": "Valitse kiinteistö",
    "k9": "Mukautettu sopimustunnus (valinnainen):",
    "k10": "Mukautettu sopimustunnus",
    "k11": "Vuokralainen:",
    "k12": "Valitse vuokralainen",
    "k13": "Sopimuksen alkamispäivä:",
    "k14": "Sopimuksen päättymispäivä:",
    "k15": "Kuukausivuokra:",
    "k16": "Kuukausivuokra",
    "k17": "Sopimustyyppi:",
    "k18": "Sopimustyyppi",
    "k19": "Sopimuskausi (kk):",
    "k20": "Sopimuskausi (kk)",
    "k21": "Tila:",
    "k22": "Aktiivinen",
    "k23": "Odottaa tarkistusta",
    "k24": "Päättynyt",
    "k25": "Irtisanottu",
    "k26": "Huomautukset",
    "k27": "Luo vuokrasopimus",
    "k28": "Peruuta",
    "k29": "Muokkaa sopimusta (ID:",
    "k30": "Kiinteistö:",
    "k31": "Valitse vuokralainen (valinnainen)",
    "k32": "Päivitä vuokrasopimus",
    "k33": "Vuokrasopimuksia ei löytynyt",
    "k34": "Vuokrasopimus:",
    "k35": "Järjestelmän ID:",
    "k36": "Vuokranantaja:",
    "k37": "Vuokrakausi:",
    "k38": "–",
    "k39": "Vuokra:",
    "k40": "Vuokravakuus:",
    "k41": "Muokkaa",
    "k42": "Poista",
    "k43": "Näytä asiakirja",
    "k44": "Raakadata",
    "k45": "Purettu raakadata",
    "k46": "Sulje",
    "k47": "Poista vuokrasopimus"
  },
  "marketAnalysis": {
    "k1": "&larr; Takaisin kiinteistöihin",
    "k2": "Markkina-analyysi",
    "k3": "Haetaan analyysia...",
    "k4": "Hae markkina-analyysi",
    "k5": "Tallenna tulos",
    "k6": "Ladataan analyysia...",
    "k7": "Kiinteistön markkina-analyysi",
    "k8": "Kohdekiinteistön tiedot",
    "k9": "Osoite:",
    "k10": "Kiinteistötyyppi:",
    "k11": "Pinta-ala (sq ft):",
    "k12": "Vertailukelpoinen markkinadata",
    "k13": "Löydettyjä vertailukohteita:",
    "k14": "Keskimääräinen hinta per sq ft (vertailukohteet):",
    "k15": "Keskimääräinen myyntihinta (vertailukohteet):",
    "k16": "Keskimääräinen pinta-ala (vertailukohteet):",
    "k17": "Markkinakommentaari:",
    "k18": "Yhteenveto:",
    "k19": "Keskeiset trendit:",
    "k20": "Suositus:"
  },
  "marketComps": {
    "k1": "Ladataan markkinavertailuja...",
    "k2": "Virhe:",
    "k3": "Lisää uusi vertailukauppa",
    "k4": "Osoite",
    "k5": "Kaupantekopäivä",
    "k6": "Kauppahinta",
    "k7": "Pinta-ala (sq ft)",
    "k8": "Lisää vertailukohde",
    "k9": "Markkinavertailut",
    "k10": "Markkinavertailuja ei löytynyt.",
    "k11": "Hinta/sq ft",
    "k12": "Toiminnot",
    "k13": "Muokkaa",
    "k14": "Poista"
  },
  "navbar": {
    "k1": "CRE Dominion",
    "k2": "Ydin",
    "k3": "Hallintapaneeli",
    "k4": "Kiinteistöt",
    "k5": "Vuokralaiset",
    "k6": "Vuokrasopimukset",
    "k7": "Dokumentit",
    "k8": "Vuokrasopimusten abstraktio",
    "k9": "Lataa vuokrasopimuksia",
    "k10": "Kasvu",
    "k11": "Hankinta",
    "k12": "Underwriting",
    "k13": "Tili",
    "k14": "Kirjaudu ulos"
  },
  "occupancyChart": {
    "k1": "Käyttöaste",
    "k2": "Nykyinen käyttöaste",
    "k3": "Prosenttiosuus (%)"
  },
  "overduePaymentsSection": {
    "k1": "Erääntyneet maksut",
    "k2": "Erääntynyt:",
    "k3": "Vuokrasopimuksen ID:",
    "k4": "Ei erääntyneitä maksuja."
  },
  "predictiveTrends": {
    "k1": "&larr; Takaisin kiinteistöihin",
    "k2": "Ennakoivat trendit",
    "k3": "Syötä kiinteistön ID...",
    "k4": "Haetaan trendejä...",
    "k5": "Hae ennakoivat trendit",
    "k6": "Tallenna tulos",
    "k7": "Kiinteistön trendiennuste",
    "k8": "Tavoitepäivämäärä:",
    "k9": "Ennustettu arvo:",
    "k10": "Luottamusindeksi:",
    "k11": "Perustelu:",
    "k12": "Virhe:",
    "k13": "Raakavastaus:"
  },
  "privacyPolicy": {
    "k1": "&larr; Takaisin etusivulle",
    "k2": "CRE Dominionin tietosuojaseloste",
    "k3": "Tämä tietosuojaseloste kuvaa, kuinka CRE Dominion (\"me\") kerää, käyttää ja luovuttaa tietojasi käyttäessäsi verkkopalveluamme (\"Palvelu\"). Olemme sitoutuneet suojaamaan yksityisyyttäsi ja käsittelemään tietojasi avoimesti ja läpinäkyvästi.",
    "k4": "Tietojen kerääminen ja käyttö",
    "k5": "Keräämme erityyppisiä tietoja Palvelumme tarjoamiseksi ja parantamiseksi. Kun kirjaudut sisään Google-tunnuksillasi, keräämme henkilötietoja, kuten nimesi ja sähköpostiosoitteesi Google-tililtäsi. Näitä tietoja käytetään käyttäjätilisi luomiseen ja hallintaan CRE Dominionissa sekä käyttökokemuksesi personointiin. Palvelun käytön aikana voit antaa meille lisätietoja, kuten kiinteistötietoja, vuokrasopimuksia, vuokralaistietoja ja muuta kiinteistöalan dataa. Tätä käyttäjän toimittamaa sisältöä tallennetaan ja käsitellään Palvelun ydintoimintojen, kuten vuokrasopimusten abstraktion, kiinteistönhallinnan ja markkina-analyysin, toteuttamiseksi. Keräämme myös käyttötietoja, jotka voivat sisältää tietoja, kuten tietokoneesi IP-osoitteen, selaintyypin, selainversion, Palvelumme sivut, joilla vierailet, vierailun ajan ja päivämäärän, näillä sivuilla vietetyn ajan, yksilölliset laitetunnisteet ja muita diagnostiikkatietoja. Nämä tiedot auttavat meitä ymmärtämään, miten Palveluamme käytetään, ja mahdollistavat sen suorituskyvyn ja ominaisuuksien parantamisen.",
    "k6": "Tietojen tallennus ja käsittely",
    "k7": "Tietojasi, mukaan lukien henkilötiedot ja käyttäjän toimittama sisältö, tallennetaan ja käsitellään Google Cloud -ekosysteemissä. Tämä sisältää Google Cloud SQL:n tietokantojen hallintaan, Google Cloud Storagen asiakirjojen tallennukseen sekä Google Cloudin Vertex AI:n ja Geminin edistyneeseen analytiikkaan ja koneoppimistoimintoihin, kuten vuokrasopimusten abstraktioon ja trendiennusteisiin. Varmistamme, että käytössä on asianmukaiset tietoturvatoimenpiteet tietojesi suojaamiseksi näiden palveluiden käsittelyn aikana.",
    "k8": "Evästeet ja seurantateknologiat",
    "k9": "Käytämme evästeitä ja vastaavia seurantateknologioita Palvelumme toiminnan seuraamiseen ja tiettyjen tietojen tallentamiseen. Evästeet ovat pieniä tiedostoja, jotka verkkosivusto lähettää selaimeesi ja jotka tallennetaan laitteellesi. Käytämme myös majakoita, tunnisteita ja skriptejä tietojen keräämiseen ja seuraamiseen sekä Palvelumme analysointiin ja parantamiseen. Voit määrittää selaimesi hylkäämään kaikki evästeet tai ilmoittamaan, kun eväste lähetetään. Jos et kuitenkaan hyväksy evästeitä, et ehkä voi käyttää kaikkia Palvelumme osia.",
    "k10": "Tietojen jakaminen ja luovuttaminen",
    "k11": "Emme myy henkilötietojasi. Voimme jakaa tietojasi kolmannen osapuolen palveluntarjoajien kanssa Palvelumme helpottamiseksi, Palvelun tarjoamiseksi puolestamme, Palveluun liittyvien toimintojen suorittamiseksi tai avustamaan meitä Palvelumme käytön analysoinnissa. Näillä kolmansilla osapuolilla on pääsy henkilötietoihisi vain näiden tehtävien suorittamiseksi puolestamme, ja ne ovat velvollisia olemaan luovuttamatta tai käyttämättä niitä muihin tarkoituksiin. Voimme myös luovuttaa henkilötietojasi hyvässä uskossa, jos katsomme sen olevan tarpeen lakisääteisten velvoitteiden noudattamiseksi, CRE Dominionin oikeuksien tai omaisuuden suojaamiseksi ja puolustamiseksi, Palveluun liittyvän mahdollisen väärinkäytöksen estämiseksi tai tutkimiseksi, Palvelun käyttäjien tai yleisön henkilökohtaisen turvallisuuden suojaamiseksi tai oikeudelliselta vastuulta suojautumiseksi.",
    "k12": "Tietojen säilytys",
    "k13": "Säilytämme henkilötietojasi vain niin kauan kuin se on tarpeen tässä tietosuojakäytännössä määriteltyjen tarkoitusten toteuttamiseksi. Säilytämme ja käytämme henkilötietojasi siinä laajuudessa kuin se on tarpeen lakisääteisten velvoitteidemme noudattamiseksi, kiistojen ratkaisemiseksi sekä sopimustemme ja käytäntöjemme täytäntöönpanemiseksi.",
    "k14": "Tietosuojaoikeutesi",
    "k15": "Sijainnistasi riippuen sinulla voi olla seuraavat tietosuojaoikeudet: oikeus päästä käsiksi tietoihisi, päivittää tai poistaa niitä; oikeus tietojen oikaisemiseen; oikeus vastustaa käsittelyä; oikeus käsittelyn rajoittamiseen; oikeus siirtää tiedot järjestelmästä toiseen sekä oikeus peruuttaa suostumuksesi. Käyttääksesi näitä oikeuksia, ota meihin yhteyttä alla olevien yhteystietojen kautta.",
    "k16": "Tilin ja tietojen poistopyynnöt",
    "k17": "Google Play -tietojen poistamista koskeva ilmoitus:",
    "k18": "CRE Dominion tarjoaa käyttäjille täyden hallinnan tiliinsä ja henkilötietoihinsa. Sinulla on oikeus pyytää tilisi ja kaikkien siihen liittyvien henkilötietojen poistamista milloin tahansa.",
    "k19": "Kuinka pyytää tilin ja tietojen poistamista:",
    "k20": "Lähetä sähköpostia osoitteeseen",
    "k21": "aiheotsikolla",
    "k22": "\"Account Deletion Request\"",
    "k23": "Liitä mukaan CRE Dominion -tiliisi rekisteröity sähköpostiosoite.",
    "k24": "Asiakastukemme käsittelee poistopyyntösi 7 arkipäivän kuluessa ja vahvistaa toimenpiteen suorittamisen.",
    "k25": "Pysyvästi poistettavat tiedot:",
    "k26": "Tilin tunnistetiedot (sähköposti, nimi, profiilitiedot, UID).",
    "k27": "Ladattujen vuokrasopimusasiakirjojen, PDF-tiedostojen ja mukautetun asiakirjaholvin sisältö.",
    "k28": "Tallennetut kiinteistöprofiilit, vuokralaislistat ja taloudelliset arviointiraportit.",
    "k29": "Tietojen säilyttämistä koskevat poikkeukset:",
    "k30": "Tietyt anonymisoidut järjestelmän diagnostiikkalokit tai laskutustiedot voidaan säilyttää väliaikaisesti lakisääteisten velvoitteiden, taloudellisten tarkastusten tai petosten ehkäisyä koskevien vaatimusten mukaisesti sovellettavan lainsäädännön puitteissa.",
    "k31": "Lasten yksityisyys",
    "k32": "Palvelumme ei ole tarkoitettu alle 13-vuotiaiden lasten käyttöön. Emme tietoisesti kerää henkilötietoja alle 13-vuotiailta. Jos olet vanhempi tai huoltaja ja tiedät lapsesi luovuttaneen meille henkilötietoja, ota meihin yhteyttä. Jos saamme tietää keränneemme henkilötietoja lapsilta ilman vanhempien suostumuksen todentamista, ryhdymme toimenpiteisiin tietojen poistamiseksi palvelimiltamme.",
    "k33": "Muutokset tähän tietosuojakäytäntöön",
    "k34": "Voimme päivittää tietosuojakäytäntöämme ajoittain. Ilmoitamme muutoksista julkaisemalla uuden tietosuojakäytännön tällä sivulla. Suosittelemme tarkistamaan tämän tietosuojakäytännön säännöllisesti mahdollisten muutosten varalta. Muutokset tähän tietosuojakäytäntöön astuvat voimaan, kun ne julkaistaan tällä sivulla.",
    "k35": "Ota yhteyttä",
    "k36": "Jos sinulla on kysyttävää tästä tietosuojakäytännöstä tai haluat pyytää tietojen poistamista, ota meihin yhteyttä osoitteeseen support@credominion.com."
  },
  "properties": {
    "k1": "Virhe:",
    "k2": "Kiinteistöt",
    "k3": "Muokkaa kiinteistöä",
    "k4": "Lisää uusi kiinteistö",
    "k5": "Automaattinen haku OM-asiakirjasta",
    "k6": "Järjestelmätunnus:",
    "k7": "Osoite",
    "k8": "Kaupunki",
    "k9": "Osavaltio",
    "k10": "Postinumero",
    "k11": "Kiinteistötyyppi",
    "k12": "Kiinteistötunnus (valinnainen)",
    "k13": "Pinta-ala",
    "k14": "Huoneistojen määrä",
    "k15": "Ostohinta",
    "k16": "Nykyarvo",
    "k17": "Rakennusvuosi",
    "k18": "Kuvaus",
    "k19": "Päivitä kiinteistö",
    "k20": "Lisää kiinteistö",
    "k21": "Peruuta muokkaus",
    "k22": "Omat kiinteistöt",
    "k23": "Kiinteistöjä ei löytynyt",
    "k24": "Tyyppi:",
    "k25": "Koko:",
    "k26": "sq ft",
    "k27": "Yksiköitä:",
    "k28": "Ostohinta:",
    "k29": "Nykyarvo:",
    "k30": "Rakennusvuosi:",
    "k31": "Kuvaus:",
    "k32": "Muokkaa",
    "k33": "Poista",
    "k34": "Markkina-analyysi",
    "k35": "Arvonmääritys",
    "k36": "Ennakoivat trendit",
    "k37": "Poista kiinteistö"
  },
  "propertyDetailView": {
    "k1": "Ladataan kiinteistön tietoja...",
    "k2": "Virhe:",
    "k3": "&larr; Takaisin kiinteistöihin",
    "k4": "Kiinteistötunnus:",
    "k5": "Kiinteistötunnus",
    "k6": "Järjestelmätunnus",
    "k7": "Kiinteistötyyppi",
    "k8": "Pinta-ala",
    "k9": "sqft",
    "k10": "Yksiköiden määrä",
    "k11": "Ostohinta",
    "k12": "Nykyarvo",
    "k13": "Rakennusvuosi",
    "k14": "Kuvaus"
  },
  "propertyDocuments": {
    "k1": "Ladataan asiakirjoja...",
    "k2": "Virhe:",
    "k3": "Kiinteistöasiakirjat",
    "k4": "Tälle kiinteistölle ei löytynyt asiakirjoja.",
    "k5": "Tyyppi:",
    "k6": "Kuvaus:",
    "k7": "Ladattu:",
    "k8": "Näytä",
    "k9": "Muokkaa",
    "k10": "Poista"
  },
  "propertyInsights": {
    "k1": "Näytä vähemmän",
    "k2": "Näytä lisää",
    "k3": "Ladataan kiinteistöanalyyseja...",
    "k4": "Virhe:",
    "k5": "Kiinteistöanalyysit (tekoälyllä tuotettu)",
    "k6": "Tälle kiinteistölle ei ole vielä saatavilla tekoälypohjaisia analyyseja.",
    "k7": "Yksityiskohdat:",
    "k8": "Lähdeote:",
    "k9": "Analysoitu:"
  },
  "propertyLeases": {
    "k1": "Ladataan vuokrasopimuksia...",
    "k2": "Virhe:",
    "k3": "Kiinteistövuokrasopimukset",
    "k4": "Tälle kiinteistölle ei löytynyt vuokrasopimuksia.",
    "k5": "Vuokrasopimus:",
    "k6": "Järjestelmätunniste:",
    "k7": "Vuokralainen:",
    "k8": "Alkamispäivä:",
    "k9": "Päättymispäivä:",
    "k10": "Vuokra:",
    "k11": "Näytä",
    "k12": "Muokkaa",
    "k13": "Poista"
  },
  "propertyTypeChart": {
    "k1": "Kiinteistöjen määrä",
    "k2": "Kiinteistöjakauma tyypeittäin"
  },
  "publicNavbar": {
    "k1": "CRE Dominion",
    "k2": "Etusivu",
    "k3": "Live-seulonta",
    "k4": "Tietopankki",
    "k5": "Yhteystiedot",
    "k6": "Kirjaudu sisään"
  },
  "quickActionsSection": {
    "k1": "Pikatoiminnot",
    "k2": "Lisää uusi kiinteistö",
    "k3": "Lisää uusi vuokrasopimus",
    "k4": "Lataa asiakirja",
    "k5": "Käyttöönotto",
    "k6": "Tervetuloa CRE-Dominion-palveluun!",
    "k7": "Pääset alkuun seuraamalla näitä yksinkertaisia vaiheita:",
    "k8": "Lisää ensimmäinen kiinteistösi:",
    "k9": "Siirry \"Kiinteistöt\"-osioon ja napsauta \"Lisää uusi kiinteistö\". Tämä luo perustan koko kiinteistönhallinnallesi.",
    "k10": "Lataa vuokrasopimukset:",
    "k11": "Kun olet lisännyt kiinteistön, siirry sen tietosivulle ja lataa siihen liittyvät vuokrasopimukset. Tekoälymme auttaa keskeisten tietojen abstrahoinnissa.",
    "k12": "Hallitse asiakirjoja:",
    "k13": "Käytä \"Asiakirjat\"-sivua muiden olennaisten tiedostojen, kuten tilinpäätösten tai markkinaraporttien, lataamiseen.",
    "k14": "Tutustu ominaisuuksiin:",
    "k15": "Syvenny \"Markkinavertailuihin\", \"Talouslukuihin\" ja \"Kalenteriin\" nähdäksesi, kuinka CRE-Dominion tehostaa toimintaasi. Kokeile rohkeasti!",
    "k16": "Selvä!"
  },
  "recentActivitySection": {
    "k1": "Viimeaikainen toiminta",
    "k2": "Ei viimeaikaista toimintaa.",
    "k3": "Näytä lisää"
  },
  "summaryReportSection": {
    "k1": "Ladataan yhteenvetoraporttia...",
    "k2": "Virhe:",
    "k3": "Yhteenvetoraportti",
    "k4": "Kiinteistöjä yhteensä",
    "k5": "Vuokralaisia yhteensä",
    "k6": "Asiakirjoja yhteensä",
    "k7": "Keskimääräinen kuukausivuokra"
  },
  "tenants": {
    "k1": "Ladataan vuokralaisia...",
    "k2": "Virhe:",
    "k3": "Vuokralaiset",
    "k4": "Muokkaa vuokralaista",
    "k5": "Lisää uusi vuokralainen",
    "k6": "Etunimi",
    "k7": "Sukunimi",
    "k8": "Sähköposti",
    "k9": "Puhelinnumero",
    "k10": "Syntymäaika:",
    "k11": "Päivitä vuokralainen",
    "k12": "Lisää vuokralainen",
    "k13": "Peruuta muokkaus",
    "k14": "Vuokralaisesi",
    "k15": "Vuokralaisia ei löytynyt. Lisää uusi yllä!",
    "k16": "Sähköposti:",
    "k17": "Puhelin:",
    "k18": "Syntymäaika:",
    "k19": "Muokkaa",
    "k20": "Poista"
  },
  "termsOfService": {
    "k1": "&larr; Takaisin etusivulle",
    "k2": "CRE Dominionin käyttöehdot",
    "k3": "Tervetuloa CRE Dominionin palveluun. Nämä käyttöehdot (\"Ehdot\") säätelevät pääsyäsi CRE Dominionin verkkosivustolle ja palveluihin (yhteisesti \"Palvelu\"). Käyttämällä Palvelua sitoudut noudattamaan näitä Ehtoja. Jos et hyväksy ehtoja tai niiden osia, et saa käyttää Palvelua.",
    "k4": "Käyttäjätilit",
    "k5": "Luodessasi tilin palveluumme, sinun on annettava tarkat, täydelliset ja ajantasaiset tiedot. Tämän laiminlyönti katsotaan Ehtojen rikkomiseksi, mikä voi johtaa tilisi välittömään sulkemiseen. Olet vastuussa salasanasi suojaamisesta ja kaikesta toiminnasta, joka tapahtuu tililläsi, riippumatta siitä, käytätkö omaa vai kolmannen osapuolen palvelua. Sitoudut olemaan luovuttamatta salasanaasi kolmansille osapuolille. Sinun on ilmoitettava meille välittömästi, jos havaitset tietoturvaloukkauksen tai tilisi luvatonta käyttöä.",
    "k6": "Hyväksyttävä käyttö",
    "k7": "Sitoudut olemaan käyttämättä Palvelua laittomiin tarkoituksiin tai muihin näiden Ehtojen kieltämiin tarkoituksiin. Sitoudut olemaan käyttämättä Palvelua tavalla, joka voi vahingoittaa, poistaa käytöstä, ylikuormittaa tai heikentää Palvelua tai häiritä muiden osapuolten pääsyä Palveluun. Et saa hankkia tai yrittää hankkia materiaaleja tai tietoja millään tavalla, jota ei ole tarkoituksellisesti asetettu saataville Palvelun kautta.",
    "k8": "Immateriaalioikeudet",
    "k9": "Palvelu ja sen alkuperäinen sisältö (lukuun ottamatta käyttäjien tuottamaa sisältöä), ominaisuudet ja toiminnallisuudet ovat ja pysyvät CRE Dominionin ja sen lisenssinantajien yksinomaisena omaisuutena. Palvelu on suojattu tekijänoikeus-, tavaramerkki- ja muilla Yhdysvaltojen sekä muiden maiden laeilla. Tavaramerkkejämme ja liiketunnuksiamme ei saa käyttää minkään tuotteen tai palvelun yhteydessä ilman CRE Dominionin kirjallista suostumusta. Säilytät kaikki oikeudet sisältöön, jonka lähetät, julkaiset tai näytät Palvelussa tai sen kautta.",
    "k10": "Linkit muihin verkkosivustoihin",
    "k11": "Palvelumme voi sisältää linkkejä kolmansien osapuolten verkkosivustoille tai palveluihin, jotka eivät ole CRE Dominionin omistuksessa tai hallinnassa. CRE Dominionilla ei ole määräysvaltaa eikä se vastaa kolmansien osapuolten sivustojen tai palveluiden sisällöstä, tietosuojakäytännöistä tai toimintatavoista. Hyväksyt ja ymmärrät, ettei CRE Dominion ole suoraan tai välillisesti vastuussa vahingoista tai menetyksistä, joiden väitetään aiheutuneen tällaisten sivustojen tai palveluiden käytöstä tai niihin luottamisesta. Suosittelemme vahvasti lukemaan kaikkien vierailemiesi kolmansien osapuolten sivustojen käyttöehdot ja tietosuojakäytännöt.",
    "k12": "Palvelun päättäminen",
    "k13": "Voimme päättää tai keskeyttää tilisi välittömästi ilman ennakkoilmoitusta tai vastuuta mistä tahansa syystä, mukaan lukien Ehtojen rikkominen. Palvelun päättyessä oikeutesi käyttää Palvelua lakkaa välittömästi. Jos haluat sulkea tilisi, voit yksinkertaisesti lopettaa Palvelun käytön.",
    "k14": "Vastuuvapauslauseke",
    "k15": "Käytät Palvelua omalla vastuullasi. Palvelu tarjotaan \"SELLAISENA KUIN SE ON\" ja \"SAATAVILLA OLEVANA\". Palvelua tarjotaan ilman minkäänlaisia takuita, joko nimenomaisia tai hiljaisia, mukaan lukien, mutta ei rajoittuen, hiljaiset takuut kaupallisesta hyödynnettävyydestä, soveltuvuudesta tiettyyn tarkoitukseen, loukkaamattomuudesta tai suoritustavasta. CRE Dominion ei takaa, että Palvelu toimii keskeytyksettä, turvallisesti tai on saatavilla tiettynä aikana tai tietyssä paikassa; että virheet tai puutteet korjataan; että Palvelu on vapaa viruksista tai muista haitallisista komponenteista; tai että Palvelun käytön tulokset vastaavat vaatimuksiasi.",
    "k16": "Vastuunrajoitus",
    "k17": "CRE Dominion, sen johtajat, työntekijät, kumppanit, edustajat, tavarantoimittajat tai tytäryhtiöt eivät ole missään olosuhteissa vastuussa mistään epäsuorista, satunnaisista, erityisistä, välillisistä tai rangaistusluonteisista vahingoista, mukaan lukien rajoituksetta voiton, datan, käyttöoikeuden, liikearvon tai muiden aineettomien hyödykkeiden menetykset, jotka johtuvat (i) pääsystäsi palveluun, sen käytöstä tai kyvyttömyydestä käyttää palvelua; (ii) kolmannen osapuolen toiminnasta tai sisällöstä palvelussa; (iii) palvelusta hankitusta sisällöstä; ja (iv) luvattomasta pääsystä lähetyksiisi tai sisältöösi, niiden käytöstä tai muuttamisesta, perustuipa se takuuseen, sopimukseen, vahingonkorvausoikeudelliseen perusteeseen (mukaan lukien huolimattomuus) tai muuhun oikeudelliseen teoriaan, riippumatta siitä, onko meitä informoitu tällaisen vahingon mahdollisuudesta, ja vaikka tässä määritellyn oikeussuojakeinon katsottaisiin epäonnistuneen olennaisessa tarkoituksessaan.",
    "k18": "Sovellettava laki",
    "k19": "Näitä ehtoja säädellään ja tulkitaan Yhdysvaltojen Kalifornian osavaltion lakien mukaisesti ottamatta huomioon lainvalintaa koskevia säännöksiä. Se, ettemme käytä jotakin näiden ehtojen mukaista oikeutta tai määräystä, ei tarkoita kyseisestä oikeudesta luopumista. Jos tuomioistuin toteaa jonkin näiden ehtojen määräyksen pätemättömäksi tai täytäntöönpanokelvottomaksi, näiden ehtojen muut määräykset pysyvät voimassa. Nämä ehdot muodostavat koko sopimuksen meidän välillämme koskien palveluamme ja korvaavat kaikki aiemmat sopimukset, joita meillä on saattanut olla palveluun liittyen.",
    "k20": "Ehtojen muutokset",
    "k21": "Pidätämme oikeuden oman harkintamme mukaan muuttaa tai korvata nämä ehdot milloin tahansa. Jos kyseessä on olennainen muutos, pyrimme ilmoittamaan siitä vähintään 30 päivää ennen uusien ehtojen voimaantuloa. Se, mikä katsotaan olennaiseksi muutokseksi, määritetään oman harkintamme mukaan. Jatkamalla palvelumme käyttöä näiden muutosten voimaantulon jälkeen sitoudut noudattamaan muutettuja ehtoja. Jos et hyväksy uusia ehtoja, lopeta palvelun käyttö.",
    "k22": "Ota yhteyttä",
    "k23": "Jos sinulla on kysyttävää näistä ehdoista, ota meihin yhteyttä osoitteessa support@credominion.com."
  },
  "underwritingToolkit": {
    "k1": "Kiinteistösijoitusten analyysityökalu",
    "k2": "Kiinteistö- ja rahoitustiedot",
    "k3": "Ostohinta",
    "k4": "Vuotuinen bruttovuokratulo",
    "k5": "Muut vuotuiset tulot (esim. pysäköinti, pesula)",
    "k6": "Käyttöasteen vajaus (%)",
    "k7": "Vuotuiset ylläpitokustannukset",
    "k8": "Vuotuiset peruskorjausinvestoinnit (CapEx)",
    "k9": "Lainan määrä",
    "k10": "Korko (%)",
    "k11": "Laina-aika (vuotta)",
    "k12": "Kaupankäyntikulut (%)",
    "k13": "Keskeiset tunnusluvut",
    "k14": "Tehollinen bruttotulo",
    "k15": "Nettotuotto (NOI)",
    "k16": "Tuottovaatimus (Cap Rate)",
    "k17": "Sijoitettu pääoma yhteensä",
    "k18": "Vuotuinen velanhoitokulu",
    "k19": "Vuotuinen kassavirta",
    "k20": "Oman pääoman tuotto (Cash-on-Cash)",
    "k21": "Velanhoitokate (DSCR)",
    "k22": "Bruttovuokrakerroin (GRM)",
    "k23": "Lainan osuus arvosta (LTV)"
  },
  "upcomingPaymentsSection": {
    "k1": "Tulevat maksut (30 päivää)",
    "k2": "Eräpäivä:",
    "k3": "Vuokrasopimuksen ID:",
    "k4": "Ei tulevia maksuja."
  },
  "vacancyRateChart": {
    "k1": "Käyttöasteen trendit"
  },
  "valuation": {
    "k1": "&larr; Takaisin kiinteistöihin",
    "k2": "Kiinteistön arvonmääritys",
    "k3": "Vertailukaupat",
    "k4": "Tuottoarvomenetelmä",
    "k5": "Kassavirta-analyysi (DCF)",
    "k6": "Kustannusarvomenetelmä",
    "k7": "Suoritetaan arvonmääritystä...",
    "k8": "Suorita arvonmääritys",
    "k9": "Tallenna tulos",
    "k10": "Ladataan arvonmääritystä...",
    "k11": "Kiinteistön arvonmääritys",
    "k12": "Arvonmäärityksen yhteenveto:",
    "k13": "Suositeltu loppuarvo:",
    "k14": "Arvonmäärityspäivä:",
    "k15": "Arvonmääritysmenetelmä:",
    "k16": "Oletukset:",
    "k17": "Vastuuvapauslauseke:",
    "k18": "Arvonmäärityksen tiedot:"
  },
  "articleCard": {
    "k1": "Julkaistu:",
    "k2": "Lue lisää"
  },
  "leaseInsightWidget": {
    "k1": "Välitön AI-analyysi (CRE)",
    "k2": "Analysoi vuokrasopimukset, tilinpäätökset tai markkinaraportit välittömästi.",
    "k3": "Liitä sopimusehto tai yhteenveto",
    "k4": "esim. 'Vuokralaisella on oikeus irtisanoa tämä sopimus, mikäli vuokranantaja ei toimita...'",
    "k5": "Vaihda asiakirja",
    "k6": "Lataa PDF/Doc",
    "k7": "Tukee PDF-tiedostoja 5 Mt asti",
    "k8": "Suorita analyysi nyt →",
    "k9": "Käsitellään älykästä analyysia...",
    "k10": "Kokeilujakson raja saavutettu",
    "k11": "Luo ilmainen työtila →",
    "k12": "Takaisin widgetiin",
    "k13": "Luottamustaso:",
    "k14": "Nollaa",
    "k15": "Johtopäätökset",
    "k16": "Strateginen toimintasuunnitelma",
    "k17": "Avaa ammattilaistason salkkuanalyysi →"
  },
  "bottomCTA": {
    "k1": "Lopeta rahan",
    "k2": "jättäminen pöydälle.",
    "k3": "Liity yli 500 CRE-ammattilaisen joukkoon, jotka automatisoivat vuokrasopimusten analysoinnin, löytävät off-market-kohteita ja maksimoivat salkun ROI:n tekoälyn avulla.",
    "k4": "Aloita ilmaiseksi →",
    "k5": "Luottokorttia ei vaadita"
  },
  "insufficientCreditsModal": {
    "k1": "Krediitit loppu",
    "k2": "Olet käyttänyt aktiiviset krediittisi. Lataa lisää krediittejä avataksesi rajoittamattoman pääsyn tekoälypohjaiseen vuokrasopimusten analysointiin, ennustavaan analytiikkaan ja automatisoituihin arvonmääritystyökaluihin.",
    "k3": "Välitön vuokrasopimusten analysointi",
    "k4": "Poimi keskeiset ehdot ja taloudelliset tiedot viiveettä.",
    "k5": "Arvonmääritystyökalut",
    "k6": "Luo yksityiskohtaisia arvostuksia ja tuottoennusteita.",
    "k7": "Ennustava trendianalyysi",
    "k8": "Simuloi alueellisia ja hinnoittelumuutoksia ajan kuluessa.",
    "k9": "Markkina-analyysimoottori",
    "k10": "Suorita vertailuanalyysejä ja makrotason arviointeja.",
    "k11": "Osta krediittipaketteja",
    "k12": "Hanki 125 krediittiä 50 dollarilla ja jatka kauppojen käsittelyä.",
    "k13": "Hanki krediittejä"
  },
  "contact": {
    "k1": "Ota yhteyttä CRE Dominion | Institutionaalinen kiinteistöalan alusta",
    "k2": "Ota yhteyttä CRE Dominion",
    "k3": "CRE Dominion",
    "k4": "Suora tuki",
    "k5": "Onko sinulla kysyttävää tekoälypohjaisesta vuokrasopimusten analysoinnista, arvonmääritysprosesseista tai yritystason salkkuintegraatioista? Kiinteistöteknologian asiantuntijatiimimme on valmiina auttamaan.",
    "k6": "Asiakas- ja tekninen tuki",
    "k7": "Tiliä koskevat kysymykset, vuokrasopimusten analysoinnin varmennus ja tekninen tuki.",
    "k8": "SLA: Alle 4 arkityötuntia",
    "k9": "Yhteydenottopyyntö lähetetty",
    "k10": "Kiitos yhteydenotostanne CRE Dominionille. Viestinne on ohjattu kohteeseen",
    "k11": ". Jos sähköpostisovelluksesi ei avautunut automaattisesti, klikkaa alta varmistaaksesi tai lähettääksesi viestin sähköpostiohjelmastasi.",
    "k12": "Avaa sähköpostisovelluksessa",
    "k13": "Lähetä uusi viesti",
    "k14": "Lähetä yhteydenottopyyntö",
    "k15": "Koko nimi *",
    "k16": "Sarah Connor",
    "k17": "Työsähköposti *",
    "k18": "Yritys / Portfolio",
    "k19": "Apex Asset Management",
    "k20": "Yhteydenoton tyyppi",
    "k21": "Yleinen tuki",
    "k22": "Yrityslisenssit",
    "k23": "API-integraatio",
    "k24": "Laskutus ja tilaus",
    "k25": "Tietoturva ja vaatimustenmukaisuus",
    "k26": "Viesti *",
    "k27": "Kuvaile portfolion tarpeita, kiinteistövolyymeja tai teknistä kysymystäsi...",
    "k28": "Suojattu TLS 1.3 -salauksella. Emme koskaan jaa kaupallista dataasi.",
    "k29": "Lähetä yhteydenottopyyntö",
    "k30": "Usein kysytyt kysymykset &rarr;",
    "k31": "Tietosuojaseloste",
    "k32": "Käyttöehdot",
    "k33": "CRE-tietopankki"
  },
  "instantUnderwritingWidget": {
    "k1": "⚡ Interaktiivinen underwriting-työkalu",
    "k2": "Ei vaadi kirjautumista",
    "k3": "Institutionaalinen CRE-underwriting ja tuottomallinnus",
    "k4": "Vaihda Yhdysvaltojen, Ison-Britannian ja Euroopan kiinteistöstandardien välillä. Välitön matemaattinen todennus kaupan tunnusluvuille.",
    "k5": "🇺🇸 Yhdysvallat",
    "k6": "🇬🇧 Yhdistynyt kuningaskunta",
    "k7": "🇪🇺 Pohjoismaat ja Eurooppa",
    "k8": "Eurooppalainen valuutta:",
    "k9": "kr",
    "k10": "Yhteensopiva pohjoismaisen elinkustannusindeksin ja metristen standardien (`m²`) kanssa",
    "k11": "Pikavalinnat:",
    "k12": "🏢 Toimistokiinteistö",
    "k13": "🏭 Logistiikka / Teollisuus",
    "k14": "🏬 Monikäyttö / Asuinkerrostalo",
    "k15": "Ostohinta / Arvonmääritys (",
    "k16": "Bruttovuokratulot / vuosi (",
    "k17": "Vuokrattava pinta-ala yhteensä (",
    "k18": "Käyttöasteen vajaus / Tyhjyysaste (%)",
    "k19": "Ylläpitokulut / vuosi (",
    "k20": "Velka- ja rahoitusoletukset",
    "k21": "LTV-suhde (",
    "k22": "Korkotaso (",
    "k23": "Lainan takaisinmaksuaika (",
    "k24": "vuotta)",
    "k25": "Pikatuottoprofiili",
    "k26": "Vahvistettu kaava",
    "k27": "Nettotuotto (NOI)",
    "k28": "Oman pääoman tuotto (Cash-on-Cash)",
    "k29": "Velanhoitokyky (DSCR)",
    "k30": "Käteiskauppa",
    "k31": "Bruttotuotto",
    "k32": "Vuotuinen kassavirta",
    "k33": "Yksikkövuokra:",
    "k34": "/ vuosi",
    "k35": "Omarahoitusosuus:",
    "k36": "Tallenna kohde ja vie esite (ilmainen)",
    "k37": "Sisältää 125 ilmaista aloituspistettä rekisteröitymisen yhteydessä. Luottokorttia ei vaadita."
  },
  "articleDetailPage": {
    "k1": "Virhe:",
    "k2": "Artikkelia ei löytynyt.",
    "k3": "CRE Dominion",
    "k4": "Takaisin tietopankkiin",
    "k5": "• Julkaistu",
    "k6": "Tietoa kirjoittajasta",
    "k7": "Takaisin alkuun",
    "k8": "Lue lisää artikkeleita"
  },
  "blogListPage": {
    "k1": "Ladataan blogikirjoituksia...",
    "k2": "Virhe:",
    "k3": "Tietopankki – Asiantuntijatason näkemyksiä kaupallisesta kiinteistöalasta | CRE Dominion",
    "k4": "Tietopankki",
    "k5": "Edellinen sivu",
    "k6": "Edellinen",
    "k7": "Seuraava sivu",
    "k8": "Seuraava",
    "k9": "Ei blogikirjoituksia saatavilla. Pysy kuulolla!"
  },
  "adminSEOPage": {
    "k1": "Ladataan SEO-hallintapaneelia...",
    "k2": "Virhe:",
    "k3": "SEO-automaation hallintapaneeli",
    "k4": "Luodut artikkelit",
    "k5": "Ei vielä luotuja artikkeleita."
  },
  "demoPage": {
    "badge": "60 sekunnin interaktiivinen hiekkalaatikko",
    "title": "Toimitilavuokrasopimusten abstrahointi ja CAM-auditointi sekunneissa",
    "subtitle": "Auditoi automaattisesti toimitilavuokrasopimukset, CAM-kulukorvauskatot, elinkustannusindeksit ja vuokrarullien poikkeamat pitkistä PDF-sopimuksista.",
    "step1Title": "Vuokradokumentin lataus",
    "step1Desc": "Lataa yli 50-sivuiset toimitilavuokrasopimukset tai liitä monimutkaiset CAM- ja indeksilausekkeet.",
    "step2Title": "Tekoälyn lausekeanalyysi",
    "step2Desc": "Gemini 3.8 Flash erottelee perusvuokran, kuluosuusrajat, CAM-katot, indeksipäivät ja tarkastusajat.",
    "step3Title": "Auditointitaulukko & riskit",
    "step3Desc": "Tunnistaa ylihinnoittelut, kertyvät CAM-kululoukut ja tekemättömät indeksikorotukset.",
    "widgetHeader": "Interaktiivinen vuokralausekeanalysaattori",
    "widgetSub": "Liitä vuokralauseke tai lataa PDF-katkelma alle reaaliaikaista purkua varten.",
    "liveBadge": "Live taustajärjestelmän päätepiste",
    "whyTitle": "Miksi kiinteistösijoittajat luottavat CRE-Dominioniin",
    "benefit1Title": "1. Ei manuaalista vuokratietojen syöttöä",
    "benefit1Desc": "Muuta 80-sivuinen pääsopimus todennetuksi tiivistelmäksi 30 sekunnissa 4 tunnin sijaan.",
    "benefit2Title": "2. Estä CAM-ylilaskutus",
    "benefit2Desc": "Ristiintarkista hallittavat ja ei-hallittavat kulukatot ennen vuosittaista täsmäytystä.",
    "benefit3Title": "3. Automatisoidut indeksikorotukset",
    "benefit3Desc": "Älä koskaan ohita vuotuista inflaatiotarkistusta tai määräaikaa toimitilasalkussasi.",
    "ctaText": "Valmis kokeilemaan CRE-Dominionia omaan toimitilasalkkuusi?",
    "ctaBtn": "Aloita ilmainen 14 päivän kokeilu ->",
    "signIn": "Kirjaudu sisään",
    "requestPilot": "Pyydä kokeilua"
}
,
  "about": {
    "pageTitle": "Tietoa meistä & Johto | CRE-Dominion Toimitilakiinteistöjen Älykkyys",
    "navHome": "Etusivu",
    "navResearch": "Tutkimus",
    "navContact": "Ota yhteyttä",
    "navSignIn": "Kirjaudu sisään",
    "navPilot": "Pyydä kokeilua",
    "heroBadge": "Institutionaalinen toimitilakiinteistöjen analytiikka",
    "heroTitle": "Suunniteltu institutionaalisille varainhoitajille & välittäjille",
    "heroSubtitle": "CRE-Dominion automatisoi toimitilavuokrasopimusten abstrahoinnin, kulujen täsmäytyksen ja algoritmisen riskienarvioinnin. Poistamme manuaalisen työn, jotta kiinteistötoimijat tekevät päätöksiä empiirisellä tarkkuudella.",
    "pillar1Title": "Automatisoitu vuokrasopimusten abstrahointi",
    "pillar1Desc": "Pura vuokra-aikataulut, korotusehdot, optiot ja kriittiset päättymispäivät yli 80-sivuisista sopimuksista sekunneissa.",
    "pillar2Title": "Ennakoiva analyysi & underwriting",
    "pillar2Desc": "Algoritminen arvonmääritysmoottori, joka stressitestaa tuottovaatimuksia, nettotuottotasoja ja velanhoitokykyä reaaliaikaisiin markkinatietoihin verrattuna.",
    "pillar3Title": "Pankkitason luottamuksellisuus",
    "pillar3Desc": "Tiukka moniasiakaskryptografinen eristys. Kiinteistörekisterejä, vuokrasopimuksia tai laskelmia ei koskaan käytetä tekoälymallien kouluttamiseen.",
    "founderLeadership": "Johtoryhmä",
    "founderName": "Ghazwan Alemara",
    "founderRole": "Perustaja & Lead Systems Architect · CRE-Dominion",
    "founderSub": "Data Geniusin tukemana",
    "founderLinkedIn": "Verkostoidu LinkedInissä",
    "founderBio1": "Ghazwan Alemara on CRE-Dominionin perustaja ja pääjärjestelmäarkkitehti, jonka taustalla toimii ohjelmisto- ja tutkimusstudio Data Genius. Erikoistuttuaan yritysjärjestelmäarkkitehtuuriin ja kvantitatiiviseen ohjelmistosuunnitteluun Ghazwan kehitti CRE-Dominionin ratkaisemaan toimitilavuokrauksen ja analyysin informaatioepätasapainon.",
    "founderBio2": "Hänellä on järjestelmätieteiden maisterin tutkinto (M.Sc.) Tukholman yliopistosta (EQF-taso 7), ja hän soveltaa deterministisiä laskentamalleja korvaamaan virhealttiit taulukkolaskennat algoritmisella analyysillä ja automaattisella auditoinnilla.",
    "card1Label": "Koulutus",
    "card1Val": "M.Sc. Järjestelmätieteet",
    "card1Sub": "Tukholman yliopisto (EQF 7)",
    "card2Label": "Arkkitehtuuri",
    "card2Val": "Lead Systems Architect",
    "card2Sub": "Algoritminen kiinteistöäly",
    "card3Label": "Kehitysstudio",
    "card3Val": "Data Genius",
    "card3Sub": "Sovellettu järjestelmä-T&K",
    "card4Label": "Tietosuoja",
    "card4Val": "Zero-Trust-eristys",
    "card4Sub": "Institutionaalinen yksityisyys",
    "ctaTitle": "Ota CRE-Dominion käyttöön kiinteistösalkussasi",
    "ctaDesc": "Koe 60 sekunnin vuokrasopimusabstrahointi ja institutionaalinen analyysi aktiivisissa kohteissasi pilottiohjelmamme kautta.",
    "ctaBtn": "Pyydä institutionaalinen pilotti",
    "ctaDemo": "Tutustu 60 sekunnin demoon",
        "secBadge": "Pankkitason luottamuksellisuus & Datasuvereniteetti",
    "secTitle": "Institutionaalinen tietoturva & Zero-Trust-yksityisyys",
    "secSub": "Suunniteltu erityisesti institutionaalisille kiinteistösijoittajille, rahastoille ja välittäjille luottamuksellisiin analyyseihin.",
    "secCard1Title": "Ei tekoälymallien koulutusta",
    "secCard1Desc": "Vuokrasopimuksesi ja talousmallisi ovat täysin eristettyjä. Emme koskaan kouluta yleisiä tekoälymalleja asiakastiedoilla.",
    "secCard2Title": "AES-256 & TLS 1.3 -salaus",
    "secCard2Desc": "Kaikki asiakirjojen käsittely ja talouskirjat salataan siirrossa ja levossa automaattisella tiedostojen poistomahdollisuudella.",
    "secCard3Title": "Tiukka asiakasympäristöjen eristys",
    "secCard3Desc": "Työtilakohtaiset IAM-pääsynvalvonnat. Ei organisaatioiden välistä tietovuotoa, mikä takaa täyden kaupallisen luottamuksellisuuden.",
    "secCard4Title": "SOC-2 & GDPR -valmis arkkitehtuuri",
    "secCard4Desc": "Täysi EU- ja globaalien tietosuojasäännösten noudattaminen, muuttumattomat tarkastuslokit ja paikallinen datasuvereniteetti.",
    "pilotBadge": "Institutionaalinen riskinpoisto",
    "pilotTitle": "14 päivän institutionaalinen pilottiohjelma",
    "pilotSub": "Arvioi CRE-Dominion riskittömästi aktiivisissa kiinteistöhankkeissasi ennen yritystason käyttöönottoa.",
    "pilotStep1Title": "1. Empiirinen vuokrasopimusvertailu",
    "pilotStep1Desc": "Lataa 5-10 monimutkaisinta toimitilavuokrasopimustasi. Testaa poimintanopeutta, kulunjakoja ja tarkkuutta asiantuntijoitasi vastaan.",
    "pilotStep2Title": "2. Räätälöity arvonmäärityksen kalibrointi",
    "pilotStep2Desc": "Kalibroimme arvonmääritysalgoritmit, DCF-tuottovaatimukset ja kassavirtaraportit sijoituskomiteasi kriteerien mukaisiksi.",
    "pilotStep3Title": "3. Suora johtavan arkkitehdin SLA",
    "pilotStep3Desc": "Suora yhteys pääjärjestelmäarkkitehti Ghazwan Alemaraan, alle 60 sekunnin asiakirjakäsittelyn SLA ja ensiluokkainen tuki.",
    "footerRights": "CRE-Dominion · Data Genius -hanke. Kaikki oikeudet pidätetään."
}
};
